import React, { Component } from 'react';
import Masthead from '../../components/Masthead/Masthead';
import PrimaryNav from '../../components/PrimaryNav/PrimaryNav';
import Footer from '../../components/Footer/Footer';
import Legal from '../../components/Legal/Legal';
import MainImage from '../../components/MainImage/MainImage';
import HomeBoxes from '../../components/HomeBoxes/HomeBoxes';
import Cats from '../../components/Cats/Cats';

class PageHome extends Component {

  render() {
    return (
      <div className="app pageHome">
          <Masthead />
            <PrimaryNav title="" transparent="true" />
            <div className="page-outer">
                <div role="main" className="container page">
                    <div className="row">
                        <div className="col-sm-5">
                            <div className="home-message">
                                <h1>Our promise</h1>
                                <p>is simply to take the best possible care of our clients &ndash; to keep their interests first and foremost to ensure total client satisfaction.</p>
                            </div>
                        </div>
                        <div className="col-sm-7">
                            <MainImage/>
                        </div>
                    </div>
                </div>
            </div>
            <HomeBoxes />
            <Footer />
            <Legal />
            <Cats />
      </div>
    );
  }
}

export default PageHome;



// WEBPACK FOOTER //
// ./src/pages/PageHome/PageHome.js